import React, { useEffect, useState, useRef } from "react";
import MUIDataTable from "mui-datatables";
import useStyles from "./styles";
import axios from 'axios';
import Notification from "../../components/Notification/Notification";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import { toast } from "react-toastify";
import { Button, Typography } from '../../components/Wrappers/Wrappers'
import { documentTableOptions, measureTableOptions } from '../tables/TableOptions';
import { findInObjectData, cleanseDateStringFromT } from '../../helpers/storedDataHelper';
import { withStyles } from '@material-ui/styles'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import checkedImage from '../../images/CheckMark.png';
import checkedImageYellow from '../../images/CheckMarkOrange.png';
import {
    Publish,
    Delete,
    GetApp,
    MoreVert,
    Assignment,
    ExpandMore,
    Speed,
    Edit
} from '@material-ui/icons'
import Widget from "../../components/Widget/Widget";
import missingImage from '../../images/missingImage.png';
import miniLogo from "../../images/CheckABminiopaque.png";
import {
    Select,
    InputLabel,
    FormHelperText,
    FormControl,
    Fade,
    Backdrop,
    Modal,
    Grid,
    Box,
    Menu,
    MenuItem,
    CircularProgress,
    Checkbox,
    TextField
} from "@material-ui/core";
import ActionModal from "../../components/ActionModal";

export default function DocumentItem() {
    const currentDate = new Date();
    const [documents, setDocuments] = useState([]);
    const [objectId, setObjectId] = useState("");
    const [object, setObject] = useState(null);
    const [objectName, setObjectName] = useState([]);
    const [mainImage, setMainImage] = useState("");
    const [showImage, setShowImage] = useState(true);
    const [actionModalOpen, setActionModalOpen] = useState(false);
    const [canAddDocuments, setCanAddDocuments] = useState(false);
    const [canCreateObjects, setCanCreateObjects] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [measureText, setMeasureText] = useState("");
    const [measureResponsible, setMeasureResponsible] = useState("");
    const [measureExpirationDate, setMeasureExpirationDate] = useState(getProperCurrentDate());
    const [measureStatus, setMeasureStatus] = useState(0);
    const [measureAllowProceed, setMeasureAllowProceed] = useState(false);
    const [measureColumns, setMeasureColumns] = useState();
    const [resolvedFilter, setResolvedFilter] = useState(["Ej åtgärdad", "Pågående"]);
    const [measureList, setMeasureList] = useState([]);
    const [menuPlacement, setMenuPlacement] = useState();
    const [canCreateAction, setCanCreateAction] = useState(false);
    const [showDocsNotMeasures, setShowDocsNotMeasures] = useState(true);
    const [measuresNotDone, setMeasuresNotDone] = useState(false);
    const muiTable = useRef(null);

    const classes = useStyles();

    useEffect(() => {
        let currentUser = localStorage.getItem('currentUser');

        if (currentUser) {
            currentUser = JSON.parse(currentUser);
            if (currentUser.userPermission) {
                if (currentUser.userPermission.findIndex(perm => perm.permissionID === "71") > -1) { //See if user is allowed to create documents
                    setCanAddDocuments(true);
                } else {
                    setCanAddDocuments(false);
                }

                if (currentUser.userPermission.findIndex(perm => perm.permissionID === "41") > -1) { //See if user is allowed to create documents
                    setCanCreateObjects(true);
                } else {
                    setCanCreateObjects(false);
                }
            }
        }

        const params = window.location.href.split('?')[1];

        if (params && params.length > 0) {
            const urlParams = new URLSearchParams(params);
            const id = urlParams.get('objektID');
            setObjectId(id);

            axios.get("/objects/" + id).then(
                res => {
                    if (res.status === 200) {
                        if (res.data.type.mainType.id == 3) { //Redirect to archive if object is an archive object
                            window.location.href = '/#/app/anläggningar/anläggning?objektID=' + id;
                        }

                        setDocuments(res.data.documents);
                        setObjectName(res.data.objectName);
                        setObject(res.data);

                        axios.get("/Action/getallfromobject/" + id).then(
                            res2 => {
                                if (res2.status === 200) {
                                    setMeasureList(res2.data);
                                    const objectNumber = res.data.objectNr;

                                    if (objectNumber) {
                                        setResolvedFilter(["Ej åtgärdad", "Pågående"]);
                                    }

                                    axios.get("/Action/getalldonefromobject/" + id + "?done=false").then(
                                        res3 => {
                                            if (res3.status === 200) {
                                                if (res3.data.length > 0) {
                                                    setMeasuresNotDone(true);
                                                } else {
                                                    setMeasuresNotDone(false);
                                                }
                                            }
                                        }
                                    ).catch(err => {
                                        console.log('err');
                                        console.log(err);
                                    });
                                }
                            }
                        ).catch(err => {
                            console.log('err');
                            console.log(err);
                        });

                        if (res.data.images.length > 0) {
                            setMainImage("/downloadImage/" + res.data.images[0].id);
                            setShowImage(true);
                        }
                    }
                }
            ).catch(err => {
                console.log('err');
                console.log(err);
            })
        }
    }, []);

    useEffect(() => {
        if (measureText) {
            setMeasureAllowProceed(true);
        } else {
            setMeasureAllowProceed(false);
        }
    }, [measureText])

    useEffect(() => {
        let currentUser = localStorage.getItem('currentUser');
        if (currentUser) {
            currentUser = JSON.parse(currentUser);

            if (currentUser.userPermission) {
                if (currentUser.userPermission.findIndex(perm => perm.permissionID === "51") > -1) {
                    setCanCreateAction(true);
                } else {
                    setCanCreateAction(false);
                }
            }
        }

        setMeasureColumns(
            [
                {
                    name: "",
                    options: {
                        filter: false,
                        viewColumns: false
                    }
                },
                {
                    name: "Åtgärdat",
                    options: {
                        display: "true",
                        filterList: resolvedFilter,
                        customBodyRender: (value, tableMeta, updateValue) => {
                            if (value === "Åtgärdad") {
                                return <img style={{ width: "32px" }} src={checkedImage} />
                            } else if (value === "Pågående") {
                                return <img style={{ width: "32px" }} src={checkedImageYellow} />
                            } else {
                                return <span></span>
                            }
                        },
                    }
                },
                {
                    name: "Åtgärdstext",
                    options: {
                        filter: false,
                        display: "true",
                        customBodyRender: (value, tableMeta, updateValue) => {
                            return <span style={{ whiteSpace: "pre-wrap" }}>{value}</span>;
                        },
                    }
                },
                {
                    name: "Skapad",
                    options: {
                        filter: false,
                        display: "true",
                        customBodyRender: (value, tableMeta, updateValue) => {
                            return <div>{cleanseDateStringFromT(value)}</div>
                        },
                    }
                },
                {
                    name: "Ändrad",
                    options: {
                        filter: false,
                        display: "true",
                        customBodyRender: (value, tableMeta, updateValue) => {
                            return <div>{cleanseDateStringFromT(value)}</div>
                        },
                    }
                },
                {
                    name: "Objektnamn",
                    options: {
                        filter: false,
                        display: "true",
                    }
                },
                {
                    name: "Objektnummer",
                    options: {
                        filter: false,
                        display: true,
                    }
                }
            ]
        );
    }, [resolvedFilter]);

    const imageModalOpenNow = () => {
        setImageModalOpen(true);
    };

    const imageModalCloseNow = () => {
        setImageModalOpen(false);
    };

    const GreenCheckbox = withStyles({
        root: {
            color: "#17a506",
            '&$checked': {
                color: "#17a506",
            },
        },
        checked: {},
    })((props) => <Checkbox color="default" {...props} />);

    const getMuiTheme = () => createMuiTheme({
        palette: {
            primary: {
                main: "#17a506"
            }
        },
        overrides: {
            MUIDataTableBodyCell: {
                root: {
                    '@media (max-width: 960px)': {
                        padding: "2px 0px 0px 4px",
                        textOverflow: "ellipsis",
                        overflow: "hidden"
                    }
                }
            },
            MUIDataTableFilterList: {
                root: {
                    '@media (max-width: 960px)': {
                        margin: "0px 16px 10px 16px"
                    }
                }
            }
        }
    })

    function getBtns(documentID) {
        return (
            <div style={{ cursor: "pointer" }} id={"menuBtn" + documentID} onClick={() => menuClick(documentID)}>
                <Edit className={classes.mobileMenuButton} />
                <MoreVert className={classes.threeDotsButton} />
            </div>
        )
    }

    function getBtnsMeasures(documentID) {
        return (
            <div style={{ cursor: "pointer" }} id={"menuBtnMeasures" + documentID} onClick={() => menuClick(documentID)}>
                <Edit className={classes.mobileMenuButton} />
                <MoreVert className={classes.threeDotsButton} />
            </div>
        )
    }

    function menuClick(objectId) {
        if (!objectId) {
            setShowMenu(false);
            return;
        }

        setMenuPlacement(objectId);
        setShowMenu(true);
    }

    function getProperCurrentDate() {
        let finalDateString = currentDate.getFullYear() + "-";

        let month = currentDate.getMonth();

        if (month < 9) {
            month = "0" + (month + 1);
        } else {
            month = "" + (month + 1)
        }

        finalDateString += month + "-";

        let day = currentDate.getDate().toString();

        if (day.length === 1) {
            day = "0" + (day);
        }

        finalDateString += day;

        return finalDateString;
    }

    function downloadBtnClick(documentID) {
        axios({
            url: "/Documents/download/" + documentID,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            //const filename = response.headers['content-disposition'].split(';')[1].split('filename=')[1];
            const doc = object.documents.find(doc => doc.id === documentID);
            const fileExtension = doc.documentFileDto.fileName.split('.')[1];
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', doc.documentName + "." + fileExtension);
            document.body.appendChild(link);
            link.click();
        });
    }

    function getStatusText(statusInt) {
        if (statusInt === 2) {
            return "Åtgärdad";
        } else if (statusInt === 1) {
            return "Pågående";
        } else {
            return "Ej åtgärdad";
        }
    }

    function addDocBtn() {
        window.location.href = '/#/app/dokument/nytt?objektID=' + objectId
    }

    function editDocBtn(e, documentID) {
        if (!canAddDocuments) {
            sendNotification("Du har inte behörighet att göra detta", false);
        } else {
            if (e.button === 0 && !e.ctrlKey) {
                window.location.href = '/#/app/dokument/redigera?dokumentID=' + documentID + "&objektID=" + objectId;
            } else if (e.button === 1 || (e.button === 0 && e.ctrlKey)) {
                window.open(
                    window.location.href = '/#/app/dokument/redigera?dokumentID=' + documentID + "&objektID=" + objectId,
                    '_blank'
                );
            }
        }
    }

    function duplicateBtnClick() {
        if (!canCreateObjects) {
            sendNotification("Du har inte behörighet att göra detta", false);
        } else {
            if (window.confirm("Är du säker på att du vill duplicera objektet?\n\nDu kommer att skickas till förteckningen")) {
                const addedString = '?objektTyp=' + (object.type.mainType.id - 1);
                axios.post("/objects/copy/" + objectId).then(
                    res => {
                        if (res.status === 200) {
                            sendDuplicatedNotification();
                            window.location.href = '/#/app/objekt/forteckning' + addedString;
                        }
                    }
                ).catch(err => {
                    console.log('err');
                    console.log(err);
                })
            }
        }
    }

    function editObjectBtnClick() {
        if (!canCreateObjects) {
            sendNotification("Du har inte behörighet att göra detta", false);
        } else {
            if (window.confirm("Är du säker på att du vill redigera objektet?\n\nDu kommer att skickas till förteckningen")) {
                window.location.href = '/#/app/objekt/redigera?objektID=' + objectId;
            }
        }
    }

    function deleteBtnClick() {
        if (!canCreateObjects) {
            sendNotification("Du har inte behörighet att göra detta", false);
        } else {
            if (window.confirm("Är du säker på att du vill ta bort objektet?\n\nDu kommer att skickas till förteckningen")) {
                const addedString = '?objektTyp=' + (object.type.mainType.id - 1);
                axios.delete("/objects/" + objectId).then(
                    res => {
                        if (res.status === 200) {
                            sendDeletedNotification();
                            window.location.href = '/#/app/objekt/forteckning' + addedString;
                        }
                    }
                ).catch(err => {
                    console.log('err');
                    console.log(err);
                })
            }
        }
    }

    function deleteDocBtnClick(documentId) {
        if (!canAddDocuments) {
            sendNotification("Du har inte behörighet att göra detta", false);
        } else {
            if (window.confirm("Är du säker på att du vill ta bort dokumentet?")) {
                axios.delete("/Documents/" + documentId).then(
                    res => {
                        if (res.status === 200) {
                            //setMenuPlacement(null);
                            setShowMenu(false);
                            let tempDoc = documents.filter(docToRemove => docToRemove.id !== documentId);
                            setDocuments(tempDoc);
                            sendDocDeletedNotification();
                        }
                    }
                ).catch(err => {
                    console.log('err');
                    console.log(err);
                })
            }
        }
    }

    function sendDuplicatedNotification() {
        const componentProps = {
            type: "feedback",
            message: "Objekt duplicerat!",
            variant: "contained",
            color: "success",
        };

        const options = {
            type: "info",
            position: toast.POSITION.TOP_RIGHT,
            progressClassName: classes.progress,
            className: classes.notification,
            timeOut: 1000,
        };

        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options
        );
    }

    function sendDeletedNotification() {
        const componentProps = {
            type: "feedback",
            message: "Objekt borttaget!",
            variant: "contained",
            color: "success",
        };

        const options = {
            type: "info",
            position: toast.POSITION.TOP_RIGHT,
            progressClassName: classes.progress,
            className: classes.notification,
            timeOut: 1000,
        };

        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options
        );
    }

    function onFilterChange(changedColumn, filterList, type) {
        setResolvedFilter(filterList[1]);
    }

    function sendDocDeletedNotification() {
        const componentProps = {
            type: "feedback",
            message: "Dokument borttaget!",
            variant: "contained",
            color: "success",
        };
        const options = {
            type: "info",
            position: toast.POSITION.TOP_RIGHT,
            progressClassName: classes.progress,
            className: classes.notification,
            timeOut: 1000,
        };

        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options
        );
    }

    function sendNotification(text, greenOverRed) {
        const componentProps = {
            type: "feedback",
            message: text,
            variant: "contained",
            color: greenOverRed ? "success" : "error"
        };
        const options = {
            type: "info",
            position: toast.POSITION.TOP_RIGHT,
            progressClassName: classes.progress,
            className: classes.notification,
            timeOut: 1000
        };
        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options
        );
    }

    function excelFunction() {
        let dateTime = new Date();
        let month = dateTime.getMonth().toString();

        if (month.length === 1) {
            month = "0" + month;
        }

        axios({
            url: "/Action/getallExcelFile",
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "Åtgärdslista_" + dateTime.getFullYear().toString() + month + dateTime.getDate().toString() + ".xlsx");
            document.body.appendChild(link);
            link.click();
        });
    }

    function getFileName(fileString) {
        return fileString.split('.')[0];
    }

    function getFileExtension(fileString) {
        return fileString.split('.')[1];
    }

    function editTemplateBtnClick(e, docName, templateId, docTypeId) {
        if (!canAddDocuments) {
            sendNotification("Du har inte behörighet att göra detta", false);
        } else {
            window.location.href = '/#/app/mallar/mall?dokumentNamn=' + docName + '&objektID=' + object.id + '&formID=' + templateId + "&dokumentTypID=" + docTypeId;

            if (e.button === 0 && !e.ctrlKey) {
                window.location.href = '/#/app/mallar/mall?dokumentNamn=' + docName + '&objektID=' + object.id + '&formID=' + templateId + "&dokumentTypID=" + docTypeId;
            } else if (e.button === 1 || (e.button === 0 && e.ctrlKey)) {
                window.open(
                    window.location.href = '/#/app/mallar/mall?dokumentNamn=' + docName + '&objektID=' + object.id + '&formID=' + templateId + "&dokumentTypID=" + docTypeId,
                    '_blank'
                );
            }
        }
    }

    function showTemplateBtnClick(e, docName, templateId, docTypeId) {
        if (e.button === 0 && !e.ctrlKey) {
            window.location.href = '/#/app/mallar/mall?dokumentNamn=' + docName + '&objektID=' + object.id + '&formID=' + templateId + "&dokumentTypID=" + docTypeId;
        } else if (e.button === 1 || (e.button === 0 && e.ctrlKey)) {
            window.open(
                '/#/app/mallar/mall?dokumentNamn=' + docName + '&objektID=' + object.id + '&formID=' + templateId + "&dokumentTypID=" + docTypeId,
                '_blank'
            );
        }
    }

    function onColumnViewChange(changedColumn, action) {
        let tempObjectColumns = [...measureColumns];
        let changingColumn = tempObjectColumns.find(object => object.name === changedColumn);

        if (action === "add") {
            changingColumn.options.display = "true";
        } else if (action === "remove") {
            changingColumn.options.display = "false"
        }

        localStorage.setItem('objectColumns', JSON.stringify(tempObjectColumns));
    }

    function getFileTypeText(document) {
        if (document.formID) {
            if (document.formDto.statusID === 3) {
                return <span style={{ color: "#17a506" }}>Mall</span>;
            } else if (document.formDto.statusID === 2) {
                return <span style={{ color: "#ffa500" }}>Mall</span>;
            } else {
                return <span>Mall</span>;
            }
        }

        if (document.documentFileDto) {
            return document.documentFileDto.fileName.split('.')[1].toUpperCase();
        }

        return "Fil saknas";
    }

    function getRiskText(riskInt) {
        switch (riskInt) {
            case "-1":
                return "Saknas"
            case "0":
                return "Ej godkänd än"
            case "1":
                return "Ja, finns"
            default:
                return;
        }
    }

    function getLLJText(riskInt) {
        switch (riskInt) {
            case "-1":
                return "Saknas"
            case "0":
                return "Nej, men finns"
            case "1":
                return "Ja, finns"
            default:
                return;
        }
    }

    function editBtnClick(e, measureId) {
        if (!canCreateAction) {
            sendNotification("Du har inte behörighet att göra detta", false);
        } else {
            if (e.button === 0 && !e.ctrlKey) {
                window.location.href = '/#/app/åtgärdspunkter/redigera?åtgärdsID=' + measureId;
            } else if (e.button === 1 || (e.button === 0 && e.ctrlKey)) {
                window.open(
                    '/#/app/åtgärdspunkter/redigera?åtgärdsID=' + measureId,
                    '_blank'
                );
            }
        }
    }

    function delBtnClick(measureId) {
        if (!canCreateAction) {
            sendNotification("Du har inte behörighet att göra detta", false);
        } else {
            if (window.confirm("Är du säker på att du vill ta bort åtgärdspunkten?")) {
                axios.delete("/action/" + measureId).then(
                    res => {
                        if (res.status === 200) {
                            setMeasureList(measureList.filter(measure => measure.id != measureId));
                            sendDeletedNotification();
                        }
                    }
                ).catch(err => {
                    console.log('err');
                    console.log(err);
                })
            }
        }
    }

    function goToMeasurePoints() {
        window.location.href = '/#/app/åtgärdspunkter/åtgärdslista?ObjektNummer=' + object.objectNr;
    }

    function openObject(e, measureId) {
        let openObjectId = measureList.find(measure => measure.id === measureId).object.id;

        if (e.button === 0 && !e.ctrlKey) {
            window.location.href = '/#/app/objekt/dokument?objektID=' + openObjectId;
        } else if (e.button === 1 || (e.button === 0 && e.ctrlKey)) {
            window.open(
                '/#/app/objekt/dokument?objektID=' + openObjectId,
                '_blank'
            );
        }
    }

    function getDocMenuBtns() {
        let chosenDoc = documents.find(doc => doc.id === menuPlacement);
        if (showMenu && chosenDoc) {
            return (<Menu
                id="profile-menu"
                open={true}
                className={classes.headerMenu}
                onClose={() => menuClick(null)}
                classes={{ paper: classes.profileMenu }}
                anchorEl={document.getElementById(showDocsNotMeasures ? ("menuBtn" + menuPlacement) : ("menuBtnMeasures" + menuPlacement))}
                disableAutoFocusItem
            >
                {(chosenDoc.formID && chosenDoc.formDto.statusID === 1) &&
                    <MenuItem
                        onMouseDown={e => editTemplateBtnClick(e, chosenDoc.documentName, chosenDoc.formID, chosenDoc.type.id)}
                    >
                        <Assignment className={classes.profileMenuIcon} /> <span style={!canAddDocuments ? { textDecoration: "line-through" } : {}}> Redigera </span>
                    </MenuItem>
                }
                {(chosenDoc.formID && chosenDoc.formDto.statusID === 3) &&
                    <MenuItem
                        onMouseDown={e => showTemplateBtnClick(e, chosenDoc.documentName, chosenDoc.formID, chosenDoc.type.id)}
                    >
                        <Assignment className={classes.profileMenuIcon} /> Visa
                    </MenuItem>
                }
                {!chosenDoc.formID && <>
                    {chosenDoc.documentFileDto ?
                        <MenuItem
                            onClick={() => downloadBtnClick(menuPlacement)}
                        >
                            <GetApp className={classes.profileMenuIcon} /> Ladda ned fil
                        </MenuItem>
                        :
                        <>
                            <MenuItem
                                onMouseDown={e => editDocBtn(e, menuPlacement)}
                            >
                                <Publish className={classes.profileMenuIcon} /> <span style={!canAddDocuments ? { textDecoration: "line-through" } : {}}> Ladda upp fil </span>
                            </MenuItem>
                        </>
                    }
                </>}

                <MenuItem
                    onClick={() => deleteDocBtnClick(menuPlacement)}
                >
                    <Delete className={classes.profileMenuIcon} /> <span style={!canAddDocuments ? { textDecoration: "line-through" } : {}}> Ta bort </span>
                </MenuItem>
            </Menu>)
        }

        return null;
    }

    const actionModalOpenNow = () => {
        setActionModalOpen(true);
        setShowDocsNotMeasures(false);
    };

    function getMenuBtns() {
        if (showDocsNotMeasures) {
            let chosenDoc = documents.find(doc => doc.id === menuPlacement);
            if (showMenu && chosenDoc) {
                return (
                    <Menu
                        id="profile-menu"
                        open={true}
                        className={classes.headerMenu}
                        onClose={() => menuClick(null)}
                        classes={{ paper: classes.profileMenu }}
                        anchorEl={document.getElementById("menuBtn" + menuPlacement)}
                        disableAutoFocusItem
                    >
                        {(chosenDoc.formID && chosenDoc.formDto.statusID === 1) &&
                            <MenuItem
                                onClick={e => showTemplateBtnClick(e, chosenDoc.documentName, chosenDoc.formID, chosenDoc.type.id)}
                            >
                                <Assignment className={classes.profileMenuIcon} /> <span style={!canAddDocuments ? { textDecoration: "line-through" } : {}}> Redigera </span>
                            </MenuItem>
                        }
                        {(chosenDoc.formID && chosenDoc.formDto.statusID === 3) &&
                            <MenuItem
                                onClick={e => showTemplateBtnClick(e, chosenDoc.documentName, chosenDoc.formID, chosenDoc.type.id)}
                            >
                                <Assignment className={classes.profileMenuIcon} /> Visa
                            </MenuItem>
                        }
                        {!chosenDoc.formID && <>
                            {chosenDoc.documentFileDto ?
                                <MenuItem
                                    onClick={() => downloadBtnClick(menuPlacement)}
                                >
                                    <GetApp className={classes.profileMenuIcon} /> Ladda ned fil
                                </MenuItem>
                                :
                                <>
                                    <MenuItem
                                        onClick={() => editDocBtn(menuPlacement)}
                                    >
                                        <Publish className={classes.profileMenuIcon} /> <span style={!canAddDocuments ? { textDecoration: "line-through" } : {}}> Ladda upp fil </span>
                                    </MenuItem>
                                </>
                            }
                        </>}

                        <MenuItem
                            onClick={() => deleteDocBtnClick(menuPlacement)}
                        >
                            <Delete className={classes.profileMenuIcon} /> <span style={!canAddDocuments ? { textDecoration: "line-through" } : {}}> Ta bort </span>
                        </MenuItem>
                    </Menu>
                )
            }
        } else {
            if (showMenu) {
                return (<Menu
                    id="profile-menu"
                    open={true}
                    className={classes.headerMenu}
                    onClose={() => menuClick(null)}
                    classes={{ paper: classes.profileMenu }}
                    anchorEl={document.getElementById("menuBtnMeasures" + menuPlacement)}
                    disableAutoFocusItem
                >
                    <MenuItem
                        onMouseDown={e => editBtnClick(e, menuPlacement)}
                    >
                        <Edit className={classes.profileMenuIcon} /> <span style={!canCreateAction ? { textDecoration: "line-through" } : {}}>Redigera</span>
                    </MenuItem>
                    <MenuItem
                        onClick={() => delBtnClick(menuPlacement)}
                    >
                        <Delete className={classes.profileMenuIcon} /> <span style={!canCreateAction ? { textDecoration: "line-through" } : {}}>Ta bort</span>
                    </MenuItem>
                </Menu>)
            }
        }
    }

    const actionModalCloseNow = (save) => {
        if (save) {
            setMeasureText("");
            setMeasureExpirationDate(getProperCurrentDate());
            setMeasureResponsible("");
            setMeasureStatus(0);

            axios.get("/Action/getallfromobject" + objectId).then(
                res => {
                    if (res.status === 200) {
                        setMeasureList(res.data);
                    }
                }
            ).catch(err => {
                console.log('err');
                console.log(err);
            });
        }

        setActionModalOpen(false);
    };

    if (!object) {
        return (<CircularProgress />);
    }

    return (
        <>
            <Grid container spacing={4} className={classes.hideAllElseInPrint}>
                {showMenu && getMenuBtns()}
                <Grid container item spacing={3} xs={12} style={{ paddingBottom: 0 }}>
                    <Grid container item xs={12} sm={6}>
                        <img
                            src={miniLogo}
                            alt={"Checksoft"}
                            style={{ width: "29px", height: "29px" }}
                        />
                        <Typography variant='h4'>
                            <strong><span>{objectName}</span></strong>
                        </Typography>
                        <br />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Widget disableWidgetMenu className={classes.disableWidgetBoxShadow}>
                        <Grid container spacing={4}> {/*Pressure*/}
                            {object && object.type.mainType.id === 1 && <>
                                <Grid item xs={12} sm={6} className={classes.noTopOrBottomPadding + " " + classes.noPaddingInPrint}>
                                    <table style={{ margin: 0 }}>
                                        <tbody>
                                            <tr>
                                                <td className={classes.TableLeft}>Anläggning: </td>
                                                <td className={classes.TableRight}>{object.facility ? object.facility.name : null}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Avdelning: </td>
                                                <td className={classes.TableRight}>{object.section ? object.section.name : null}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Plats: </td>
                                                <td className={classes.TableRight}>{object.placement}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Objekttyp: </td>
                                                <td className={classes.TableRight}>{object.type.name}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Objektnummer: </td>
                                                <td className={classes.TableRight}>{object.objectNr}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Namn: </td>
                                                <td className={classes.TableRight}>{object.objectName}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Storlek: </td>
                                                <td className={classes.TableRight}>{object.volume}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Kontrollklass: </td>
                                                <td className={classes.TableRight}>{findInObjectData('classifications', object.controlClass, 'name')}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Grid>
                            </>}

                            {/*Lift*/}
                            {object && object.type.mainType.id === 2 && <Grid container item xs={12}>
                                <Grid item xs={12} sm={4} className={classes.noTopOrBottomPadding}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className={classes.TableLeft}>Anläggning: </td>
                                                <td className={classes.TableRight}>{object.facility ? object.facility.name : null}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Avdelning: </td>
                                                <td className={classes.TableRight}>{object.section ? object.section.name : null}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Plats: </td>
                                                <td className={classes.TableRight}>{object.placement}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Objekttyp: </td>
                                                <td className={classes.TableRight}>{object.type.name}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Objektnummer: </td>
                                                <td className={classes.TableRight}>{object.objectNr}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Namn: </td>
                                                <td className={classes.TableRight}>{object.objectName}</td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}><br /></td>
                                                <td className={classes.TableRight}></td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}>Lyftvikt: </td>
                                                <td className={classes.TableRight}>{(object.liftweight !== null && object.liftweight !== "") && (object.liftweight + " kg")}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Färg: </td>
                                                <td className={classes.TableRight}>{object.color}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Längd: </td>
                                                <td className={classes.TableRight}>{(object.length !== null && object.length !== "") && (object.length + " m")}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Tillv.-nr: </td>
                                                <td className={classes.TableRight}>{object.manufacturerNr}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Tillverkare: </td>
                                                <td className={classes.TableRight}>{object.manufacturer}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Tillv.-år: </td>
                                                <td className={classes.TableRight}>{object.manufacturerYear ? (object.manufacturerYear) : ""}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Grid>

                                <Grid item xs={12} sm={4} className={classes.noTopOrBottomPadding}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className={classes.TableLeft}>Kontrollföreskrift: </td>
                                                <td className={classes.TableRight}>{findInObjectData('controlRegulationsLift', object.controlRegulation, 'name')}</td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}><br /></td>
                                                <td className={classes.TableRight}></td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}>AKO: </td>
                                                <td className={classes.TableRight}>{findInObjectData('executorAKO', object.executorAKODP, 'name')}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Reg-nr: </td>
                                                <td className={classes.TableRight}>{object.regNr}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Senaste besiktning: </td>
                                                <td className={classes.TableRight}>{cleanseDateStringFromT(object.previousDateOfLiftInspection)}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Nästa besiktning: </td>
                                                <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfNextLiftInspection)}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Besiktningsintervall: </td>
                                                <td className={classes.TableRight}>{findInObjectData('liftInspections', object.liftInspectionInterval, 'name')}</td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}><br /></td>
                                                <td className={classes.TableRight}></td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}>Senaste egenkontroll: </td>
                                                <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfLastFlt)}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Nästa egenkontroll: </td>
                                                <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfNextFlt)}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Egenkontroll intervall: </td>
                                                <td className={classes.TableRight}>{findInObjectData('fltIntervalsLift', object.fltInterval, 'name')}</td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}><br /></td>
                                                <td className={classes.TableRight}></td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft} style={{ verticalAlign: "top" }}>Kommentar: </td>
                                                <td className={classes.TableRight}>{object.comment}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Grid>
                            </Grid>}

                            <Grid item xs={12} sm={6}>
                                {
                                    showImage && <>
                                        {mainImage.length > 0 ?
                                            <div className={classes.imgContainer}>
                                                <img className={classes.mainImage + " image"} src={mainImage} alt="Översiktsbild" />
                                                <div className={classes.imgMiddle + " middle"}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        style={{ height: "50%" }}
                                                        onClick={() => imageModalOpenNow()}
                                                    >
                                                        Förstora
                                                    </Button>
                                                </div>
                                            </div>
                                            :
                                            <img src={missingImage} className={classes.mainImage + " " + classes.noPrint} alt="Översiktsbild saknas" />}
                                    </>
                                }
                            </Grid>
                            {object.type.mainType.id === 1 && <Accordion className={classes.noPrint + " " + classes.topButtonContainer + " " + classes.objectDataContainer}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                >
                                    <Typography className={classes.heading}>Objektets data</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container>
                                        <Grid item xs={12} sm={6}>
                                            <Typography className={classes.heading} style={{ fontWeight: "bold" }}>Klassningsdata</Typography>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Kontrollklass: </td>
                                                        <td className={classes.TableRight}>{findInObjectData('classifications', object.controlClass, 'name')}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Dimension: </td>
                                                        <td className={classes.TableRight}>{object.dimension}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Högsta tillåtna tryck: </td>
                                                        <td className={classes.TableRight}>{object.allowedPressureOver ? (object.allowedPressureOver + " bar(g)") : ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Lägsta tillåtna tryck: </td>
                                                        <td className={classes.TableRight}>{object.allowedPressureUnder ? (object.allowedPressureUnder + " bar(g)") : ""}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Högsta tillåtna temp: </td>
                                                        <td className={classes.TableRight}>{object.allowedTemperatureHighest ? (object.allowedTemperatureHighest + " °C") : ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Lägsta tillåtna temp: </td>
                                                        <td className={classes.TableRight}>{object.allowedTemperatureLowest ? (object.allowedTemperatureLowest + " °C") : ""}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Media: </td>
                                                        <td className={classes.TableRight}>{object.media}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Riskgrupp (1a/2a): </td>
                                                        <td className={classes.TableRight}>{findInObjectData('dangerGroups', object.dangerGroup, 'name')}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Mediaform (gas/vätska): </td>
                                                        <td className={classes.TableRight}>{findInObjectData('mediaForm', object.mediaForm, 'name')}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Status: </td>
                                                        <td className={classes.TableRight}>{object.isInactive ? <span style={{ color: "#E40613" }}>Ej i drift</span> : <span style={{ color: "#17A506" }}>I drift</span>}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <Typography className={classes.heading} style={{ fontWeight: "bold", marginBottom: "0px", marginTop: "16px", verticalAlign: "top" }}>Kommentar:</Typography>
                                            <p style={{ marginTop: "0px", overflowWrap: "break-word" }}>
                                                {object.comment}
                                            </p>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography className={classes.heading} style={{ fontWeight: "bold" }}>Lagkrav <span style={{ fontStyle: "italic", fontSize: "10px" }}>(bestäms av uppladdade dokument)</span></Typography>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Kontrollföreskrift: </td>
                                                        <td className={classes.TableRight}>{findInObjectData('controlRegulations', object.controlRegulation, 'name')}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Riskbedömning: </td>
                                                        <td className={classes.TableRight}>{getRiskText(object.assessmentDataDto.riskAssessment)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Livlängdsjournal krävs: </td>
                                                        <td className={classes.TableRight}>{getLLJText(object.assessmentDataDto.llj)}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Övervakningsintervall: </td>
                                                        <td className={classes.TableRight}>{object.monitoringInterval}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Senaste FLT: </td>
                                                        <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfLastFlt)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Nästa FLT: </td>
                                                        <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfNextFlt)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>FLT Intervall: </td>
                                                        <td className={classes.TableRight}>{findInObjectData('fltIntervals', object.fltInterval, 'name')}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>IU FFM: </td>
                                                        <td className={classes.TableRight}>{object.assessmentDataDto.iuffm && (object.assessmentDataDto.iuffm === "-1," ? "Saknas" : object.assessmentDataDto.iuffm.split(',')[0])}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Intervall IU: </td>
                                                        <td className={classes.TableRight}>{object.assessmentDataDto.iuIntervall && (object.assessmentDataDto.iuIntervall === "-1," ? "Saknas" : findInObjectData('iuInspections', parseInt(object.assessmentDataDto.iuIntervall.split(',')[0]), 'name'))}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Senaste IU: </td>
                                                        <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfLastUI)}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>DP FFM: </td>
                                                        <td className={classes.TableRight}>{object.assessmentDataDto.dpffm && (object.assessmentDataDto.dpffm === "-1," ? "Saknas" : object.assessmentDataDto.dpffm.split(',')[0])}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Intervall DP: </td>
                                                        <td className={classes.TableRight}>{object.assessmentDataDto.dpIntervall && (object.assessmentDataDto.dpIntervall === "-1," ? "Saknas" : findInObjectData('dpInspections', parseInt(object.assessmentDataDto.dpIntervall.split(',')[0]), 'name'))}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Senaste DP: </td>
                                                        <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfLastDP)}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>AKO: </td>
                                                        <td className={classes.TableRight}>{findInObjectData('executorAKO', object.executorAKODP, 'name')}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Reg-nr: </td>
                                                        <td className={classes.TableRight}>{object.regNr}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Placering kontrollskylt: </td>
                                                        <td className={classes.TableRight}>{object.controlSignPosition}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Grid>
                                        <Grid item xs={12} sm={6} style={{ marginTop: "16px" }}>
                                            <Typography className={classes.heading} style={{ fontWeight: "bold" }}>Tillverkningsdata</Typography>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Tillv.-nr: </td>
                                                        <td className={classes.TableRight}>{object.manufacturerNr}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Tillverkare: </td>
                                                        <td className={classes.TableRight}>{object.manufacturer}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Tillv.-år: </td>
                                                        <td className={classes.TableRight}>{object.manufacturerYear ? (object.manufacturerYear) : ""}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Storlek: </td>
                                                        <td className={classes.TableRight}>{object.volume}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Designtryck PS högsta: </td>
                                                        <td className={classes.TableRight}>{object.designPressureOver ? (object.designPressureOver + " bar(g)") : ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Designtryck PS lägsta: </td>
                                                        <td className={classes.TableRight}>{object.designPressureUnder ? (object.designPressureUnder + " bar(g)") : ""}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Designtemp TS högsta: </td>
                                                        <td className={classes.TableRight}>{object.designTemperatureHighest ? (object.designTemperatureHighest + " °C") : ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Designtemp TS lägsta: </td>
                                                        <td className={classes.TableRight}>{object.designTemperatureLowest ? (object.designTemperatureLowest + " °C") : ""}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Ritning: </td>
                                                        <td className={classes.TableRight}>{object.blueprintNr}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Grid>
                                        <Grid item xs={6} style={{ marginTop: "16px" }}>
                                            <Typography className={classes.heading} style={{ fontWeight: "bold" }}>Ytterligare data</Typography>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Flödesschema: </td>
                                                        <td className={classes.TableRight}>{object.flowchart}</td>
                                                    </tr>
                                                    <tr><td>&zwnj;</td></tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Posnr SÄV: </td>
                                                        <td className={classes.TableRight}>{object.safetyVentPosition}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Avsäkringstryck SÄV: </td>
                                                        <td className={classes.TableRight}>{object.safetyVentPressure}</td>
                                                    </tr>
                                                    <Typography className={classes.heading} style={{ fontWeight: "bold", marginTop: "16px" }}>Placering</Typography>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Byggnad:</td>
                                                        <td className={classes.TableRight}>{object.building}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Rum: </td>
                                                        <td className={classes.TableRight}>{object.room}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={classes.TableLeft}>Dörr: </td>
                                                        <td className={classes.TableRight}>{object.door}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>}
                            <Grid container className={classes.onlyPrint}>
                                <Grid item xs={6}>
                                    <Typography className={classes.heading} style={{ fontWeight: "bold" }}>Klassningsdata</Typography>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className={classes.TableLeft}>Kontrollklass: </td>
                                                <td className={classes.TableRight}>{findInObjectData('classifications', object.controlClass, 'name')}</td>
                                            </tr>
                                            <tr><td>&zwnj;</td></tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Dimension: </td>
                                                <td className={classes.TableRight}>{object.dimension}</td>
                                            </tr>
                                            <tr><td>&zwnj;</td></tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Högsta tillåtna tryck: </td>
                                                <td className={classes.TableRight}>{object.allowedPressureOver ? (object.allowedPressureOver + " bar(g)") : ""}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Lägsta tillåtna tryck: </td>
                                                <td className={classes.TableRight}>{object.allowedPressureUnder ? (object.allowedPressureUnder + " bar(g)") : ""}</td>
                                            </tr>
                                            <tr><td>&zwnj;</td></tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Högsta tillåtna temp: </td>
                                                <td className={classes.TableRight}>{object.allowedTemperatureHighest ? (object.allowedTemperatureHighest + " °C") : ""}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Lägsta tillåtna temp: </td>
                                                <td className={classes.TableRight}>{object.allowedTemperatureLowest ? (object.allowedTemperatureLowest + " °C") : ""}</td>
                                            </tr>
                                            <tr><td>&zwnj;</td></tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Media: </td>
                                                <td className={classes.TableRight}>{object.media}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Riskgrupp (1a/2a): </td>
                                                <td className={classes.TableRight}>{findInObjectData('dangerGroups', object.dangerGroup, 'name')}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Mediaform (gas/vätska): </td>
                                                <td className={classes.TableRight}>{findInObjectData('mediaForm', object.mediaForm, 'name')}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Status: </td>
                                                <td className={classes.TableRight}>{object.isInactive ? <span style={{ color: "#E40613" }}>Ej i drift</span> : <span style={{ color: "#17A506" }}>I drift</span>}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className={classes.heading} style={{ fontWeight: "bold" }}>Lagkrav <span style={{ fontStyle: "italic", fontSize: "10px" }}>(bestäms av uppladdade dokument)</span></Typography>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className={classes.TableLeft}>Kontrollföreskrift: </td>
                                                <td className={classes.TableRight}>{findInObjectData('controlRegulations', object.controlRegulation, 'name')}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Riskbedömning: </td>
                                                <td className={classes.TableRight}>{getRiskText(object.assessmentDataDto.riskAssessment)}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Livlängdsjournal krävs: </td>
                                                <td className={classes.TableRight}>{getLLJText(object.assessmentDataDto.llj)}</td>
                                            </tr>
                                            <tr><td>&zwnj;</td></tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Övervakningsintervall: </td>
                                                <td className={classes.TableRight}>{object.monitoringInterval}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Senaste FLT: </td>
                                                <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfLastFlt)}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Nästa FLT: </td>
                                                <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfNextFlt)}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>FLT Intervall: </td>
                                                <td className={classes.TableRight}>{findInObjectData('fltIntervals', object.fltInterval, 'name')}</td>
                                            </tr>
                                            <tr><td>&zwnj;</td></tr>
                                            <tr>
                                                <td className={classes.TableLeft}>IU FFM: </td>
                                                <td className={classes.TableRight}>{object.assessmentDataDto.iuffm && (object.assessmentDataDto.iuffm === "-1," ? "Saknas" : object.assessmentDataDto.iuffm.split(',')[0])}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Intervall IU: </td>
                                                <td className={classes.TableRight}>{object.assessmentDataDto.iuIntervall && (object.assessmentDataDto.iuIntervall === "-1," ? "Saknas" : findInObjectData('iuInspections', parseInt(object.assessmentDataDto.iuIntervall.split(',')[0]), 'name'))}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Senaste IU: </td>
                                                <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfLastUI)}</td>
                                            </tr>
                                            <tr><td>&zwnj;</td></tr>
                                            <tr>
                                                <td className={classes.TableLeft}>DP FFM: </td>
                                                <td className={classes.TableRight}>{object.assessmentDataDto.dpffm && (object.assessmentDataDto.dpffm === "-1," ? "Saknas" : object.assessmentDataDto.dpffm.split(',')[0])}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Intervall DP: </td>
                                                <td className={classes.TableRight}>{object.assessmentDataDto.dpIntervall && (object.assessmentDataDto.dpIntervall === "-1," ? "Saknas" : findInObjectData('dpInspections', parseInt(object.assessmentDataDto.dpIntervall.split(',')[0]), 'name'))}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Senaste DP: </td>
                                                <td className={classes.TableRight}>{cleanseDateStringFromT(object.dateOfLastDP)}</td>
                                            </tr>
                                            <tr><td>&zwnj;</td></tr>
                                            <tr>
                                                <td className={classes.TableLeft}>AKO: </td>
                                                <td className={classes.TableRight}>{findInObjectData('executorAKO', object.executorAKODP, 'name')}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Reg-nr: </td>
                                                <td className={classes.TableRight}>{object.regNr}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Placering kontrollskylt: </td>
                                                <td className={classes.TableRight}>{object.controlSignPosition}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className={classes.heading} style={{ fontWeight: "bold", marginBottom: "0px" }}>Kommentar:</Typography>
                                    <p style={{ marginTop: "0px" }}>
                                        {object.comment}
                                    </p>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className={classes.heading} style={{ fontWeight: "bold" }}>Tillverkningsdata</Typography>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className={classes.TableLeft}>Tillv.-nr: </td>
                                                <td className={classes.TableRight}>{object.manufacturerNr}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Tillverkare: </td>
                                                <td className={classes.TableRight}>{object.manufacturer}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Tillv.-år: </td>
                                                <td className={classes.TableRight}>{object.manufacturerYear ? (object.manufacturerYear) : ""}</td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}>Storlek: </td>
                                                <td className={classes.TableRight}>{object.volume}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Designtryck PS högsta: </td>
                                                <td className={classes.TableRight}>{object.designPressureOver ? (object.designPressureOver + " bar(g)") : ""}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Designtryck PS lägsta: </td>
                                                <td className={classes.TableRight}>{object.designPressureUnder ? (object.designPressureUnder + " bar(g)") : ""}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Designtemp TS högsta: </td>
                                                <td className={classes.TableRight}>{object.designTemperatureHighest ? (object.designTemperatureHighest + " °C") : ""}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Designtemp TS lägsta: </td>
                                                <td className={classes.TableRight}>{object.designTemperatureLowest ? (object.designTemperatureLowest + " °C") : ""}</td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}>Ritning: </td>
                                                <td className={classes.TableRight}>{object.blueprintNr}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className={classes.heading} style={{ fontWeight: "bold" }}>Ytterligare data</Typography>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className={classes.TableLeft}>Flödesschema: </td>
                                                <td className={classes.TableRight}>{object.flowchart}</td>
                                            </tr>

                                            <tr>
                                                <td className={classes.TableLeft}>Posnr SÄV: </td>
                                                <td className={classes.TableRight}>{object.safetyVentPosition}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Avsäkringstryck SÄV: </td>
                                                <td className={classes.TableRight}>{object.safetyVentPressure}</td>
                                            </tr>
                                            <Typography className={classes.heading} style={{ fontWeight: "bold", marginTop: "16px" }}>Placering</Typography>
                                            <tr>
                                                <td className={classes.TableLeft}>Byggnad:</td>
                                                <td className={classes.TableRight}>{object.building}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Rum: </td>
                                                <td className={classes.TableRight}>{object.room}</td>
                                            </tr>
                                            <tr>
                                                <td className={classes.TableLeft}>Dörr: </td>
                                                <td className={classes.TableRight}>{object.door}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Grid>
                            </Grid>

                            <Grid container className={classes.noPrint + " " + classes.topButtonContainer}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => addDocBtn()}
                                    className={classes.docBtn}
                                >
                                    Lägg till dokument
                                </Button>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => duplicateBtnClick()}
                                    className={classes.docBtn}
                                    style={!canCreateObjects ? { textDecoration: "line-through" } : {}}
                                >
                                    Duplicera objekt
                                </Button>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => editObjectBtnClick()}
                                    className={classes.docBtn}
                                    style={!canCreateObjects ? { textDecoration: "line-through" } : {}}
                                >
                                    Redigera objekt
                                </Button>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => deleteBtnClick()}
                                    className={classes.docBtn}
                                    style={!canCreateObjects ? { textDecoration: "line-through" } : {}}
                                >
                                    Ta bort objekt
                                </Button>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => window.print()}
                                    className={classes.docBtn}
                                >
                                    Skriv ut objektet
                                </Button>
                                {showDocsNotMeasures &&
                                    <Button
                                        variant="contained"
                                        color={measuresNotDone ? "secondary" : "primary"}
                                        onClick={() => setShowDocsNotMeasures(!showDocsNotMeasures)}
                                        className={classes.docBtn}
                                    >
                                        Se åtgärdspunkter
                                    </Button>
                                }
                                {!showDocsNotMeasures &&
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => setShowDocsNotMeasures(!showDocsNotMeasures)}
                                        className={classes.docBtn}
                                    >
                                        Se dokument
                                    </Button>
                                }
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => { actionModalOpenNow() }}
                                    className={classes.docBtn}
                                >
                                    Skapa åtgärd
                                </Button>
                            </Grid>
                        </Grid>
                    </Widget>
                </Grid>
                {documents &&
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <Grid item xs={12} className={classes.noPrint}>
                            {showDocsNotMeasures && (<MUIDataTable
                                title={"Lista över dokument för " + objectName}
                                data={
                                    documents.map(
                                        document => {
                                            return [
                                                getBtns(document.id, document.documentFileDto != null),
                                                document.documentName,
                                                document.type.name,
                                                getFileTypeText(document),
                                                document.executiveDate ? cleanseDateStringFromT(document.executiveDate) : cleanseDateStringFromT(document.dateChanged),
                                                document.created
                                            ]
                                        }
                                    )
                                }
                                columns={
                                    [
                                        {
                                            name: "",
                                            options: {
                                                filter: false,
                                                viewColumns: false,
                                            }
                                        },
                                        {
                                            name: "Dokumentnamn"
                                        },
                                        {
                                            name: "Dokumenttyp",
                                            options: {
                                                sortDirection: 'asc'
                                            }
                                        },
                                        {
                                            name: "Filtyp"
                                        },
                                        {
                                            name: "Utförningsdatum"
                                        },
                                        {
                                            name: "Dokument Skapat"
                                        }
                                    ]
                                }
                                options={documentTableOptions(null)}
                            />)}

                            {!showDocsNotMeasures && (<MUIDataTable
                                title="Lista över åtgärdspunkter"
                                data={
                                    measureList.map(
                                        measure => {
                                            return [
                                                getBtnsMeasures(measure.id),
                                                getStatusText(measure.status),
                                                measure.actionText,
                                                measure.created,
                                                measure.changed,
                                                measure.object ? measure.object.objectName : "",
                                                measure.object ? measure.object.objectNr : ""
                                            ]
                                        }
                                    )
                                }
                                columns={measureColumns}
                                options={measureTableOptions(onColumnViewChange, onFilterChange, excelFunction, canCreateAction)}
                                key={measureList}
                                ref={muiTable}
                            />)}
                        </Grid>
                    </MuiThemeProvider>
                }

                <Modal //Enlarged image modal
                    className={classes.modalContent}
                    open={imageModalOpen}
                    onClose={() => imageModalCloseNow()}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={imageModalOpen} onClick={() => imageModalCloseNow()}>
                        <div className={classes.modalPaper} style={{ height: "90vh" }}>
                            <img src={mainImage} style={{ height: "100%", display: "block", margin: "0 auto" }} />
                        </div>
                    </Fade>
                </Modal>
                <ActionModal
                    actionModalOpen={actionModalOpen}
                    actionModalCloseNow={actionModalCloseNow}
                    objectID={objectId}
                />
            </Grid>
        </>
    );
}